import styled, { css } from 'styled-components';

import { Colors } from 'components/utils/styles/ui';
import { richContentStyles } from 'components/utils/styles/richContent';
import { Content } from 'components/text/Truncate/styles';

const plainTextStyles = css`
  p {
    margin: 0;
  }

  ul {
    list-style: disc;
    padding-left: 1.6rem;
  }

  ul,
  ol {
    margin: 0.6rem 0;
  }

  li {
    margin: 0.6rem 0;
  }

  blockquote {
    border-left: 2px solid ${Colors.textLighter};
    margin: 1rem 1rem 1rem 0;
    padding-left: 1rem;
    color: ${Colors.textLighter};
  }

  table {
    border-collapse: collapse;
  }

  table,
  th,
  td {
    border: 1px solid ${Colors.outline};
  }

  th,
  td {
    padding: 0.4rem 2.4rem;
    text-align: left;
    vertical-align: middle;
    font-size: 1rem;
  }

  th {
    background: ${Colors.tealLightest};
  }
`;

export const LongText = styled.div<{ rich?: boolean }>`
  ${({ rich }) => (rich ? richContentStyles : plainTextStyles)}

  & > :first-child,
  ${Content} > :first-child {
    margin-top: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    hyphens: auto;
  }

  & > :last-child,
  ${Content} > :last-child {
    margin-bottom: 0;
  }

  p {
    min-height: 2rem;
  }

  em {
    font-style: italic;
  }

  & > * > * > :first-child {
    margin-top: 0;
  }

  & > * > * > :last-child {
    margin-bottom: 0;
  }
`;
